import {takeEvery} from 'redux-saga/effects'
import {
  ADD_SYLLABUS,
  APPLY_SYLLABUS_ASSIGN_DATES,
  DELETE_MANY_SYLLABUS,
  DELETE_SINGLE_SYLLABUS,
  DELETE_SYLLABUS_RESOURCE,
  GET_ALL_SYLLABUS,
  GET_ONE_SYLLABUS,
  GET_SYLLABUS_ASSIGN_DATES_PREVIEW,
  GET_SYLLABUS_ASSIGN_DATES_SUMMARY,
  GET_WEIGHTAGE_SYLLABUS,
  UPDATE_SYLLABUS,
} from 'setup/redux/Actions/Syllabus/ActionTypes/ApiActionTypes'

import fetchData from '../SagaHelper'

function* dataSaga() {
  yield takeEvery(ADD_SYLLABUS, fetchData)
  yield takeEvery(GET_ALL_SYLLABUS, fetchData)
  yield takeEvery(GET_ONE_SYLLABUS, fetchData)
  yield takeEvery(DELETE_MANY_SYLLABUS, fetchData)
  yield takeEvery(DELETE_SINGLE_SYLLABUS, fetchData)
  yield takeEvery(UPDATE_SYLLABUS, fetchData)
  yield takeEvery(GET_WEIGHTAGE_SYLLABUS, fetchData)
  yield takeEvery(DELETE_SYLLABUS_RESOURCE, fetchData)
  yield takeEvery(GET_SYLLABUS_ASSIGN_DATES_SUMMARY, fetchData)
  yield takeEvery(GET_SYLLABUS_ASSIGN_DATES_PREVIEW, fetchData)
  yield takeEvery(APPLY_SYLLABUS_ASSIGN_DATES, fetchData)
  // yield takeEvery(ADD_SINGLE_TEST, fetchData)
  // yield takeEvery(UPDATE_TEST, fetchData)
  // yield takeEvery(GRADEWISE_TEST_LIMIT, fetchData)
}

export default dataSaga
